export function convertDateToPaass(date: Date | string) {
  // Create a Date object from the input string or Date object
  const inputDate = new Date(date)

  /*
  new Date("Sun May 11,2014") converts the string "Sun May 11,2014" to a date object that represents the time Sun May 11 2014 00:00:00 in a timezone based on current locale (host system settings)
new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )) converts your date to a date object that corresponds with the time Sun May 11 2014 00:00:00 in UTC (standard time) by subtracting the time zone offset
  */
  const formattedDateString = new Date(
    inputDate.getTime() - inputDate.getTimezoneOffset() * 60000,
  )
    .toISOString()
    .split('T')[0]

  return formattedDateString
}
